// import { clickShopItem } from './click-shop';

document.addEventListener('DOMContentLoaded', () => {
// 地図についての処理
  const mapMarkers = document.querySelectorAll('.map-container .marker');//地図のマーカー
  if(!mapMarkers > 0) {
    console.error('No shop container found.');
    return;
  }
  const shopContainer = document.getElementById('shop-container');//地図の左側の詳細情報
  mapMarkers.forEach(marker => {
    marker.addEventListener('click', () => {
      shopContainer.querySelector('.left img').src = marker.dataset.img;
      shopContainer.querySelector('.area').textContent = marker.dataset.area;
      shopContainer.querySelector('.shopName').innerHTML = marker.dataset.name;
      shopContainer.querySelector('.number').textContent = marker.dataset.areanumber;
      shopContainer.querySelector('.address1').textContent = marker.dataset.townaddress;
      shopContainer.querySelector('.address2').textContent = marker.dataset.address;
      shopContainer.querySelector('.link').href = '#' + marker.dataset.name;
    })
  })
  const randomIndex = Math.floor(Math.random() * mapMarkers.length);
  if(mapMarkers.length > 0) {
    mapMarkers[randomIndex].click();//mapMarkersのrandomIndexの要素をクリックする
  }

  const link = document.querySelector('#shop-container .link')
  if (link) {
    link.addEventListener('click', function() {
        const area = document.querySelector('#shop-container .area');
        const areaList = document.querySelectorAll('.gokainAreaList .area__item');
        console.log(area);
        console.log(areaList);
        if (area) {
            areaList.forEach(li => {
                if (li.textContent === area.textContent) {
                    // クリックしたリンクのエリア名と一致するリストをクリックする
                    li.click();
                }
            });
        } else {
            console.error('No area element found.');
            return;
        }
    });
  }
});

